import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.css']
})
export class ExamComponent implements OnInit {
  currentAppUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/activityPreview/index.html');
  constructor(private sanitizer: DomSanitizer) { }
  // isStageReady(state) {
  //   if (state) {

  //     let com: any = document.getElementsByClassName('examEditorContainer');
  //     if (com) {
  //       com = com[0].contentWindow;
  //       com.sendReqData('ThisIsMyData');
  //     }

  //   }
  // }
  onLoadExamIframe(evt) {
    console.log(evt);
  }
  ngOnInit() {
    // document['examNative'] = this;
  }


}



// WEBPACK FOOTER //
// ./src/app/exam/exam.component.ts